import React, { useEffect, useReducer, useState } from "react";

import logo from "../../../assets/images/sbs/sbs-logo-submit.png";
import _ from "lodash";
import { Button, Col, FormGroup, Input, Row } from "reactstrap";
import Socket from "../../../socket/socket";
import SmallBitesUsers from "../../smallBites/smallBitesUsers";
import cx from "classnames";
import LoadUploadQuestions from "./LoadUploadQuestions";
import { withRouter } from "react-router";
import { connect } from "react-redux";

import * as loaderAction from "../../../redux/loader/action";

import { compose } from "redux";

const QUESTION_OBJ = {
  question: "",
  correct_answer: "",
  answers: ["", "", "", ""],
};

function ChooseAsker({
  roomData,
  loadUploadQuestions,
  selectedAsker,
  setLoadUploadQuestions,
  setSelectedAsker,
  onTimesUp,
  ...props
}) {
  
  const status = _.get(roomData, "game_state.status");
  const dummyBit = true;

  const [showAskerModal, setshowAskerModal] = useState(false);
  const [incrementButtondisabled, setIncrementButtondisabled] = useState(false);
  const [showConfirmQuestionsModal, setShowConfirmQuestionsModal] =
    useState(false);
  const [bulkQuestion, setBulkQuestion] = useState(false);
  const [saveCurrentSetModal, setSaveCurrentSetModal] = useState(false);
  const [numQuestions, setNumQuestions] = useState(1);
  const [questionsData, setQuestionsData] = useState([QUESTION_OBJ]);
  const [activeSubmitButton, setActiveSubmitButton] = useState(false);
  const [questionSetName, setQuestionSetName] = useState("");
  const [disableSaveQuestionSetBtn, setDisableSaveQuestionSetBtn] =
    useState(false);

  const [disableCorrectAnswerCheckbox, setDisableCorrectAnswerCheckbox] =
    useState(true);


  const current_user = _.get(props, "gameReducer.currentUser");

  useEffect(() => {
    if (questionSetName !== "") {
      setDisableSaveQuestionSetBtn(false);
    } else {
      setDisableSaveQuestionSetBtn(true);
    }
  }, [questionSetName]);
  const handleSaveQuestionSet = (questionsObject) => {
    const formatted_questions = questionsObject.map((item) => {
      const correct_answer = item.answers[item.correct_answer];

      const wrong_answers = item.answers.filter(
        (ans) => ans !== correct_answer
      );

      const ob = {
        question: item.question,
        correct_answer,
        wrong_answer_1: wrong_answers[0],
        wrong_answer_2: wrong_answers[1],
        wrong_answer_3: wrong_answers[2],
      };
      return ob;
    });

    let data = {
      action: "lt-upload-question-set",
      roomId: roomData?.id,
      questions: formatted_questions,
      title: questionSetName,
      owner: current_user?.userId,
      team_id: current_user?.team.id,
      displayName: current_user?.username ? current_user?.username : "",
      profileImage: current_user?.picture ? current_user?.picture : "",
    };
    Socket.sendMessage(data);
  };

  useEffect(() => {
    let submitBit = false;
    let correctAnsBit = false;
    let checkBoxBit = false;
    let filledQuestionCheckBoxBit = false;
    let allAnswersBitarray = [];
    let allQuestionBitarray = [];
    questionsData.forEach((item) => {
      item.answers.forEach((answer, index) => {
        if (index === 0 || index === 1) {
          if (answer === "") {
            allAnswersBitarray.push(false);
          } else {
            allAnswersBitarray.push(true);
          }
        } else {
          allAnswersBitarray.push(true);
        }
      });

      if (item.question !== "") {
        allQuestionBitarray.push(true);
      } else {
        allQuestionBitarray.push(false);
      }
    });

    allQuestionBitarray.every((item) => item === true)
      ? (submitBit = true)
      : (submitBit = false);

    allAnswersBitarray.every((item) => item === true)
      ? (correctAnsBit = true)
      : (correctAnsBit = false);

    questionsData.every((item) => item.correct_answer !== "")
      ? (checkBoxBit = true)
      : (checkBoxBit = false);

    questionsData.every((item) => item.answers[item.correct_answer])
      ? (filledQuestionCheckBoxBit = true)
      : (filledQuestionCheckBoxBit = false);

    if (
      submitBit === true &&
      correctAnsBit === true &&
      checkBoxBit === true &&
      filledQuestionCheckBoxBit === true
    ) {
      setActiveSubmitButton(true);
      setIncrementButtondisabled(false);
    } else {
      setActiveSubmitButton(false);
      setIncrementButtondisabled(true);
    }
  }, [questionsData, activeSubmitButton]);

  const handleNumQuestions = (action) => {
    return action === "add"
      ? () => {
          setNumQuestions((numQuestions) => numQuestions + 1);
          // const temp = questionsData.push(QUESTION_OBJ);
          const temp = [...questionsData, QUESTION_OBJ];
          setQuestionsData(temp);
        }
      : () => {
          const pop_state = () => {
            const temp = [...questionsData];
            temp.pop();
            setQuestionsData(temp);
          };
          setNumQuestions((numQuestions) =>
            numQuestions < 2 ? 1 : numQuestions - 1
          );
          numQuestions < 2 ? void 0 : pop_state();
        };
  };
  const onSaveQuestionSet = () => {
    handleSaveQuestionSet(questionsData);
    setSaveCurrentSetModal(false);
    setShowConfirmQuestionsModal(true);
  };
  const onDontSaveQuestionSet = () => {
    setSaveCurrentSetModal(false);

    setShowConfirmQuestionsModal(true);
  };
  const onSubmitQuestions = () => {

    let data = {
      action: "lt-submit-question",
      roomId: roomData?.id,
      questions: questionsData,
    };
    Socket.sendMessage(data);
    setShowConfirmQuestionsModal(false);

  };

 

  const handleQuestionChange = (index) => (event) => {
    const userEnteredQuestion = event.target.value;

    setQuestionsData((prevData) => {

      const prevDataCopy = [...prevData];
      const prevQuestion = prevDataCopy[index];
      const prevQuestionCopy = Object.assign({}, prevQuestion);
      prevQuestionCopy.question = userEnteredQuestion;
      prevDataCopy.splice(index, 1, prevQuestionCopy);
      return prevDataCopy;
    });
  };

  const handleAnswerChange = (index) => (subIndex) => (event) => {

    const userEnteredAnswer = event.target.value;

    if (userEnteredAnswer.length === 0) {
      setActiveSubmitButton(false);
    }

    setQuestionsData((prevData) => {
      const prevDataCopy = [...prevData];

      const prevQuestion = prevDataCopy[index];
      const prevQuestionCopy = Object.assign({}, prevQuestion);
      const prevAnswers = [...prevQuestionCopy.answers];
      prevAnswers[subIndex] = userEnteredAnswer;
      prevQuestionCopy.answers = prevAnswers;
      prevDataCopy.splice(index, 1, prevQuestionCopy);
      return prevDataCopy;
    });
  };

  const handleCorrectAnswerChange = (index) => (event) => {
    const userChoiceCorrectAnswer = event.target.value;
   

    if (userChoiceCorrectAnswer !== "") {
      setQuestionsData((prevData) => {

        const prevDataCopy = [...prevData];

        const prevQuestion = prevDataCopy[index];
        const prevQuestionCopy = Object.assign({}, prevQuestion);
        prevQuestionCopy.correct_answer = +userChoiceCorrectAnswer;
        prevDataCopy.splice(index, 1, prevQuestionCopy);

        return prevDataCopy;
      });

      setActiveSubmitButton(true);
    } else {
      setActiveSubmitButton(false);
      setDisableCorrectAnswerCheckbox(false);
    }
  };

  const onConfirm = () => {
    let data = {
      action: "update-status",
      roomId: roomData?.id,
      asker: selectedAsker.player_id,
    };
    Socket.sendMessage(data);
    setshowAskerModal(false);
  };

  const renderNumQuestions = () => {
    return questionsData.map((question, index) => (
      <div
        key={index}
        className={cx("question-asker-wrapper one-question", {
          // inactive: index !== questionsData.length - 1,
        })}
      >
        <p className="que">What is your question?</p>
        <FormGroup className="textarea-group">
          <Input
            className={cx("que", {
              singleTextarea: numQuestions < 2,
            })}
            type="textarea"
            name="ask"
            placeholder="Enter Question"
            onChange={handleQuestionChange(index)}
            value={question.question}
            // disabled={index !== questionsData.length - 1}
          />
        </FormGroup>

        <div className="answers-wrap">
          <p className="quest">Enter answers and select the correct one</p>
          <div className="answers">
            <FormGroup>
              <Input
                onChange={handleAnswerChange(index)(0)}
                type="text"
                name={`answer-${index}`}
                className="ans"
                placeholder="Answer A"
                value={question.answers[0]}

              />
            </FormGroup>
            <FormGroup>
              <Input
                type="radio"
                onChange={handleCorrectAnswerChange(index)}
                disabled={question.answers[0] === ""}

                className="ans-radio"
                name={`answer-${index}`}
                value={0}

              />
            </FormGroup>
          </div>
          <div className="answers">
            <FormGroup>
              <Input
                onChange={handleAnswerChange(index)(1)}
                type="text"
                disabled={question.answers[0] === ""}
                name={`answer-${index}`}
                className="ans"
                placeholder="Answer B"
                value={question.answers[1]}

              />
            </FormGroup>
            <FormGroup>
              <Input
                type="radio"
                onChange={handleCorrectAnswerChange(index)}
                disabled={question.answers[1] === ""}

                className="ans-radio"
                name={`answer-${index}`}
                value={1}

              />
            </FormGroup>
          </div>
          <div className="answers">
            <FormGroup>
              <Input
                onChange={handleAnswerChange(index)(2)}
                disabled={question.answers[1] === ""}
                type="text"
                name={`answer-${index}`}
                className="ans"
                placeholder="Answer C"
                value={question.answers[2]}

              />
            </FormGroup>
            <FormGroup>
              <Input
                type="radio"
                onChange={handleCorrectAnswerChange(index)}
                disabled={question.answers[2] === ""}

                className="ans-radio"
                name={`answer-${index}`}
                value={2}

              />
            </FormGroup>
          </div>
          <div className="answers">
            <FormGroup>
              <Input
                onChange={handleAnswerChange(index)(3)}
                type="text"
                disabled={question.answers[2] === ""}
                name={`answer-${index}`}
                className="ans"
                placeholder="Answer D"
                value={question.answers[3]}


              />
            </FormGroup>
            <FormGroup>
              <Input
                type="radio"
                onChange={handleCorrectAnswerChange(index)}
                disabled={question.answers[3] === ""}
             
                className="ans-radio"
                name={`answer-${index}`}
                value={3}
            
              />
            </FormGroup>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div className="choose-asker-parent">
      <div className="logo-wrap">
        <img src={logo} alt="logo" />
      </div>
      {status === "ChooseAsker" && !bulkQuestion && !loadUploadQuestions && (
        <div>
          <p className="text">Select a player below to ask the question</p>
          <div className="sbs-player-container">
            <div className="sbs-players">
              <SmallBitesUsers
                onTimesUp={onTimesUp}
                dummyBit={dummyBit}
                setSelectedAsker={setSelectedAsker}
                selectedAsker={selectedAsker}
              />
            </div>
          </div>
          <div className="btn-container">
            <Button
              onClick={() => setshowAskerModal(true)}
              disabled={selectedAsker === null}
              className="asker-btn"
            >
              Select Asker
            </Button>
            <Button onClick={() => setBulkQuestion(true)} className="bulk-btn">
              Bulk Questions
            </Button>
          </div>
          <Button
            className="load-upload-btn"

            onClick={() => setLoadUploadQuestions(true)}
          >
            Load / Upload Questions
          </Button>
        </div>
      )}

      {loadUploadQuestions && <LoadUploadQuestions />}
      {showAskerModal && (
        <div className="sbs-modal-container">
          <div className="sbs-modal-dialog">
            <div className="sbs-modal-content">
              <p>You have chosen:</p>
              <h5 className="num">{selectedAsker.display_name}</h5>
              <p className="question">to ask the question.</p>
              <Button
                onClick={() => setshowAskerModal(false)}
                className="back-btn"
              >
                Back
              </Button>
              <Button onClick={() => onConfirm()} className="confirm-btn">
                Confirm
              </Button>
            </div>
          </div>
        </div>
      )}
      {showConfirmQuestionsModal && (
        <div className="sbs-modal-container">
          <div className="sbs-modal-dialog">
            <div className="sbs-modal-content">
              <p>Submit</p>
              <h5 className="num">{questionsData.length}</h5>
              <p className="question">
                {questionsData.length < 2 ? "question?" : "questions?"}
              </p>
              <Button
                onClick={() => setShowConfirmQuestionsModal(false)}
                className="back-btn"
              >
                Back
              </Button>
              <Button
                onClick={() => onSubmitQuestions()}
                className="confirm-btn"
              >
                Confirm
              </Button>
            </div>
          </div>
        </div>
      )}
      {saveCurrentSetModal && (
        <div className="save-que-modal">
          <div className="sbs-modal-dialog">
            <div className="sbs-modal-content">
              <p>Do you want to save these questions?</p>
              <FormGroup>
                <input
                  type="text"
                  name="set_name"
                  placeholder="Question Set Name"
                  onChange={(e) => {
                    setQuestionSetName(e.target.value);
                  }}
                  value={questionSetName}
                  className="form-control set-name-input"
                />
              </FormGroup>
              <p className="question">to ask the question.</p>
              <Button
                onClick={() => {
                  setSaveCurrentSetModal(false);
                }}
                className="cancel-btn"
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  onDontSaveQuestionSet();
                }}
                className="dont-btn"
              >
                Don't Save
              </Button>
              <Button
                disabled={disableSaveQuestionSetBtn}
                onClick={() => {
                  onSaveQuestionSet();
                }}
                className="confirm-btn"
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      )}
      {bulkQuestion && (
        <div>
          <p className="text">
            Enter your questions below, click + to add more questions. Don’t
            share your screen yet!
          </p>
          <div
            className={cx("more-question-container", {
              centerr: numQuestions < 2,
            })}
          >
            {renderNumQuestions()}
          </div>
          <FormGroup>
            <Button
              onClick={() => setSaveCurrentSetModal(true)}
              disabled={!activeSubmitButton}
              className="submit-que"
        
            >
              Submit Questions
            </Button>
          </FormGroup>
          <div className="askers">
            <div className="sbs-players">
       
              <SmallBitesUsers
                dummyBit={dummyBit}
                onTimesUp={onTimesUp}
                setSelectedAsker={setSelectedAsker}
                selectedAsker={selectedAsker}
              />
            </div>
          </div>
          <div className="add-minus-btn">
            <div className="add-minus-flex">
              <Button
                className="add-btn"
                disabled={incrementButtondisabled}
                onClick={handleNumQuestions("add")}
              >
                <span>+</span>
              </Button>
              <Button
                className="minus-btn"
                disabled={numQuestions === 1}
                onClick={handleNumQuestions("subtract")}
              >
                <span>-</span>
              </Button>
            </div>
          </div>
        </div>
      )}
      {status === "QuestionSubmit" && (
        <div className="confirm-asker">
          <p className="txt">Asker</p>
          <h3 className="username">{selectedAsker?.display_name}</h3>
          <p className="info">is submitting a question, hang on!</p>
          <Button onClick={() => onConfirm()} className="asker-btn">
            Choose Another Asker
          </Button>
          <div className="confirm-asker-box">
            <div className="sbs-players">
             
              <SmallBitesUsers
                dummyBit={dummyBit}
                onTimesUp={onTimesUp}
                setSelectedAsker={setSelectedAsker}
                selectedAsker={selectedAsker}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
  };
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ChooseAsker);
